import { render, staticRenderFns } from "./recyclingType.vue?vue&type=template&id=b68993ba&scoped=true"
import script from "./recyclingType.vue?vue&type=script&lang=js"
export * from "./recyclingType.vue?vue&type=script&lang=js"
import style0 from "./recyclingType.vue?vue&type=style&index=0&id=b68993ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68993ba",
  null
  
)

export default component.exports